import React from 'react';



class LatestNews extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            news: null
        };
    }


    render() {

        return (
            <div>

                <p>Loading....</p>

            </div>
        );

    }

}

export default LatestNews;



// WEBPACK FOOTER //
// ./src/components/latestNews/index.js